<div class="col-sm animated fadeIn fast" *ngIf="route.children?.length === 0 && poi">
    <div class="container" >
        <mat-card>
            <mat-card-header >
                <div 
                    mat-card-avatar 
                    class="header-image"
                >
                </div>
                <mat-card-title class="mat-fit font-text">{{poi.id}} {{poi.nombre}}</mat-card-title>
                <mat-card-subtitle class="font-text">Punto de Interés</mat-card-subtitle>
            </mat-card-header> 

            <mat-divider></mat-divider>
            
            <mat-card-content>
                <div class="row" style="padding: 15px 10px 10px 10px;">
                    <div class="col-sm-3 main-container">
                        <div class="row">
                            <div class="information">
                                <p class="subtitle">ID</p>
                                <p class="title">{{poi.id}}</p>
                                
                                <p class="subtitle">Categoría</p>
                                <p class="title"><a [routerLink]="['/', 'category', poi.categoryId]">{{poi.categoryId}}</a></p>
                            
                                <p class="subtitle">Dirección</p>
                                <p class="title">{{poi.direccionCompleta}}</p>

                                <p class="subtitle">Comuna</p>
                                <p class="title">{{poi.comuna}}</p>

                                <p class="subtitle">Ciudad</p>
                                <p class="title">{{poi.ciudad}}</p>
                            
                                <p class="subtitle">Coordenadas</p>
                                <p class="title">{{poi.lat}} , {{poi.lng}}</p>

                                <p class="subtitle">Web</p>
                                <p class="title">{{poi.web}}</p>

                                <p class="subtitle">E-mail</p>
                                <p class="title">{{poi.email}}</p>
                            </div>
                        </div>

                        <div class="row align-items-end">
                            <div class="action-buttons">
                                <a mat-stroked-button aria-label="View" matTooltip="Editar" [routerLink]="['/', 'category', poi.categoryId, 'poi', poi.id, 'edit']" (click)="setPoisToEdit()">
                                    <mat-icon>edit</mat-icon>
                                </a>
                                
                                <a mat-stroked-button aria-label="View" matTooltip="Eliminar" (click)="openDialogToDelete()">
                                    <mat-icon>delete</mat-icon>
                                </a>
                                
                                <a mat-stroked-button aria-label="View" matTooltip="Volver al inicio" [routerLink]="['/', 'category', poi.categoryId]">
                                    <mat-icon>arrow_circle_left</mat-icon>
                                </a>
                            </div>
                        </div>
                    </div>

                    <div class="col-sm">
                        <div class="map">
                            <google-map width="600px" height="450px" [zoom]="zoom" [center]="center" (mapInitialized)="onMapInitialized($event)">
                                <map-marker *ngFor="let markerPosition of markerPositions"
                                    [position]="markerPosition"
                                    [options]="markerOptions">
                                </map-marker>
                            </google-map>
                        </div>
                    </div>

                </div>              
            </mat-card-content>

            
        </mat-card> 
    </div>
</div>

<router-outlet></router-outlet>

